import Styles from './Counter.module.scss'
import cx from 'classnames'

export enum CounterSize {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
}

export enum CounterVariant {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Dark = 'dark',
  Light = 'light',
}

interface Props {
  count: number
  label?: string
  size?: CounterSize
  variant?: CounterVariant
  withBorder?: boolean
  max?: number
}

export const Counter = ({
  count,
  label,
  size = CounterSize.md,
  variant = CounterVariant.Primary,
  withBorder = false,
  max = 99,
}: Props) => {
  const displayCount =
    count > max ? (
      <>
        <span>{String(max)}</span>
        <span className={Styles.plusIcon}>+</span>
      </>
    ) : (
      <span>{String(count)}</span>
    )

  return (
    <div
      className={cx(Styles.counter, Styles[size], Styles[variant], {
        [Styles.withBorder]: withBorder,
        [Styles.withLabel]: !!label,
        [Styles.oneDigit]: count < 10,
        [Styles.twoDigit]: count >= 10 && count <= max,
        [Styles.max]: count > max,
      })}
    >
      {displayCount}
      {label && size !== CounterSize.xs && <span className={Styles.label}>{label}</span>}
    </div>
  )
}
